import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return 'Comment faire un devis artisan | Guide complet 2025'
}